import { render } from "./AddEditExtras.vue?vue&type=template&id=7a35859e&scoped=true"
import script from "./AddEditExtras.vue?vue&type=script&lang=js"
export * from "./AddEditExtras.vue?vue&type=script&lang=js"

import "./AddEditExtras.vue?vue&type=style&index=0&id=7a35859e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a35859e"]])

export default __exports__